<div class="setting-wrapper">
  <div class="left-panel">
    <div class="lp-inner-body" #menuContainer>
      <h6>Settings</h6>

      <div #menuItem (click)="setMenu('organizations')" [class.active]="activeMenu === 'organizations'"
        title="Organizations">
        <span><img src="assets/images/icon10.svg" alt="" /></span>Organizations
      </div>

      <div #menuItem (click)="setMenu('designations')" [class.active]="activeMenu === 'designations'"
        title="Designations">
        <span><img src="assets/images/icon1.svg" alt="" /></span>Designations
      </div>

      <div #menuItem (click)="setMenu('departments')" [class.active]="activeMenu === 'departments'" title="Department">
        <span><img src="assets/images/icon2.svg" alt="" /></span>Departments
      </div>
      <div #menuItem (click)="setMenu('policies')" [class.active]="activeMenu === 'policies'" title="Policies">
        <span><img src="assets/images/icon3.svg" alt="" /></span>Policies
      </div>
      <div #menuItem (click)="setMenu('leaves')" [class.active]="activeMenu === 'leaves'" title="Leave System">
        <span><img src="assets/images/icon4.svg" alt="" /></span>Leave System
      </div>
      <div #menuItem (click)="setMenu('expense')" [class.active]="activeMenu === 'expense'" title="Expense List">
        <span><img src="assets/images/icon5.svg" alt="" /></span>Expense List
      </div>
      <div #menuItem (click)="setMenu('userCheck')" [class.active]="activeMenu === 'userCheck'"
        title="User Check System">
        <span><img src="assets/images/icon6.svg" alt="" /></span>User Check
        System
      </div>
      <div #menuItem (click)="setMenu('userKps')" [class.active]="activeMenu === 'userKps'" title="User Kps List">
        <span><img src="assets/images/icon7.svg" alt="" /></span>User KPS List
      </div>
      <div #menuItem (click)="setMenu('setupText')" [class.active]="activeMenu === 'setupText'" title="Setup Text">
        <span><img src="assets/images/icon8.svg" alt="" /></span>Setup Text
        Automation
      </div>
      <div #menuItem (click)="setMenu('rolesSetup')" [class.active]="activeMenu === 'rolesSetup'" title="Roles Setup">
        <span><img src="assets/images/icon9.svg" alt="" /></span>Roles Setup
      </div>

      <div #menuItem (click)="setMenu('seeder')" [class.active]="activeMenu === 'seeder'" title="Add Seeder Data">
        <span><img src="assets/images/icon2.svg" alt="" /></span>Seeder Data
      </div>
    </div>
  </div>

  <div class="right-panel">
    <ng-container [ngSwitch]="activeMenu">
      <app-organization-table *ngSwitchCase="'organizations'" [loading]="isOrganizationsLoading" [organizations]="orgDetail"
        (addOrganization)="handleAddOrganization($event)"
        [showSkeletonTrigger]="activeMenu === 'organizations'" (editOrganization)="handleEditOrganization($event)"
        (deleteOrganization)="handleDeleteOrganization($event)"></app-organization-table>
      <app-designation-table *ngSwitchCase="'designations'" [loading]="isDesignationsLoading" [designations]="desDetail"
        [orgDetail]="orgDetail" (addDesignation)="handleAddDesignation($event)"
        [showSkeletonTrigger]="activeMenu === 'designations'" (editDesignation)="handleEditDesignation($event)"
        (deleteDesignation)="handleDeleteDesignation($event)"></app-designation-table>
      <app-department-table *ngSwitchCase="'departments'" [loading]="isDepartmentsLoading" [departments]="depDetail"
        (addDepartment)="handleAddDepartment($event)" (editDepartment)="handleEditDepartment($event)"
        (deleteDepartment)="handleDeleteDepartment($event)"></app-department-table>
      <app-policies-table *ngSwitchCase="'policies'" [loading]="isPoliciesLoading" [policies]="policyDetail"
        (addPolicy)="handleAddPolicy($event)" (editPolicy)="handleEditPolicy($event)"
        (deletePolicy)="handleDeletePolicy($event)">
      </app-policies-table>
      <app-leaves-table *ngSwitchCase="'leaves'" [loading]="isLeavesLoading" [leaves]="leaveDetail"
        (addLeave)="handleAddLeave($event)" (editLeave)="handleEditLeave($event)"
        (deleteLeave)="handleDeleteLeave($event)">
      </app-leaves-table>
      <app-expense-table *ngSwitchCase="'expense'"> </app-expense-table>
      <app-user-kps-table *ngSwitchCase="'userKps'" [loading]="isKpsLoading" [userKps]="kpsData" [office_roles_array]="office_roles_array"
        (addKps)="handleAddKps($event)" (editKps)="handleEditKps($event)" (deleteKps)="handleDeleteKps($event)">
      </app-user-kps-table>
      <app-setup-text-table *ngSwitchCase="'setupText'" [loading]="isTextLoading" [setupText]="textAutoData"
        [types]="textTypes" [orgId]="orgId" (addAutomation)="handleAddAutomation($event)"
        (editAutomation)="handleEditAutomation($event)" (deleteAutomation)="handleDeleteAutomation($event)">
      </app-setup-text-table>
      <app-user-checks-table *ngSwitchCase="'userCheck'" [loading]="isChecksLoading"
        [deviceCheck]="checksData?.device_check ?? false" [leaveCheck]="checksData?.leave_check ?? false"
        [authKey]="checksData?.authenticator_key ?? false" [leaveSetDate]="checksData?.leave_modify_date ?? null"
        [keysId]="checksData?.id ?? null" (saveChecks)="handleSaveChecks($event)"
        (deleteChecks)="handleDeleteChecks($event)">
      </app-user-checks-table>
      <app-roles-setup-table *ngSwitchCase="'rolesSetup'" [loading]="isRolesLoading" [roles]="rolesData" [departments]="depDetail"
        (deleteRole)="handleDeleteRole($event)" (editRole)="handleEditRole($event)" (roleCreated)="handleRoleCreated()">
      </app-roles-setup-table>
       <app-seeder *ngSwitchCase="'seeder'" [loading]="isSeederLoading" (addSeeder)="handleaddSeeder($event)">
      </app-seeder>
      <div *ngSwitchDefault>Select a menu item</div>
    </ng-container>
  </div>
</div>